import classnames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import { Icon } from 'palette/Icon';
import { Typography } from 'palette/Typography';

import './ColorFilterLabel.scss';

const WHITE_CHECKMARK_COLORS = [
    '6', // brown
    '10', // black
    '25', // navy blue
    '28' // burgundy
];

export function ColorFilterLabel({
    value,
    label,
    isChecked,
    isDisabled
}) {
    const [block, BEMElement] = BEMBlock('color-filter-label');
    const colorCodeClassName = `colorcode-${value}`;

    return (
        <div className={block}>
            <span className={classnames(BEMElement('box', {
                checked: isChecked,
                disabled: isDisabled
            }), colorCodeClassName)}
            >
                {
                    isChecked && (
                        <Icon
                            color={WHITE_CHECKMARK_COLORS.includes(value) ? 'white' : 'black'}
                            name="palette_check"
                            size="x-small"
                        />
                    )
                }
            </span>
            <Typography color={isDisabled ? 'lighter' : 'regular'}>{label}</Typography>
        </div>
    );
}
